<div class="register-content">
  <div class="page-title">
    <span class="font-medium-display-small text-center">
      Registriere dich und beginne zu lernen
    </span>
  </div>
  <form
    class="flex-c form-content"
    [formGroup]="registerForm"
    (ngSubmit)="register()">
    <div class="form-group">
      <label class="input-label" for="firstname">
        Vorname{{ fieldRequired(registerForm.get('firstname')) ? '*' : '' }}
      </label>
      <input
        type="firstname"
        class="form-control input-text"
        [class]="{
          'input-error':
            registerForm.get('firstname').invalid &&
            registerForm.get('firstname').touched,
          'input-success':
            registerForm.get('firstname').valid &&
            registerForm.get('firstname').touched,
        }"
        id="firstname"
        formControlName="firstname"
        placeholder="Vorname"
        autocomplete="on" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="registerForm.get('firstname')"></app-error-message>
      <label class="input-label" for="lastname">
        Nachname{{ fieldRequired(registerForm.get('lastname')) ? '*' : '' }}
      </label>
      <input
        type="lastname"
        class="form-control input-text"
        [class]="{
          'input-error':
            registerForm.get('lastname').invalid &&
            registerForm.get('lastname').touched,
          'input-success':
            registerForm.get('lastname').valid &&
            registerForm.get('lastname').touched,
        }"
        id="lastname"
        formControlName="lastname"
        placeholder="Nachname"
        autocomplete="on" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="registerForm.get('lastname')"></app-error-message>
      <label class="input-label" for="email">
        E-Mail{{ fieldRequired(registerForm.get('email')) ? '*' : '' }}
      </label>
      <input
        type="email"
        class="form-control input-text"
        [class]="{
          'input-error':
            registerForm.get('email').invalid &&
            registerForm.get('email').touched,
          'input-success':
            registerForm.get('email').valid &&
            registerForm.get('email').touched,
        }"
        id="email"
        formControlName="email"
        placeholder="E-Mail"
        autocomplete="on" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="registerForm.get('email')"></app-error-message>

      <label class="input-label" for="password">
        Passwort{{ fieldRequired(registerForm.get('password')) ? '*' : '' }}
      </label>
      <div class="password-input-wrapper">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="form-control input-text"
          [class]="{
            'input-error':
              (registerForm.get('password').invalid &&
                registerForm.get('password').touched) ||
              passwordMismatch,
            'input-success':
              registerForm.get('password').valid &&
              registerForm.get('password').touched &&
              !passwordMismatch,
          }"
          id="password"
          formControlName="password"
          placeholder="Passwort"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-button"
          (click)="togglePasswordVisibility()"
          [attr.aria-label]="
            showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'
          ">
          <i
            [class]="
              showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'
            "></i>
        </button>
      </div>
      <!-- Error Messages -->
      <app-password-error
        [control]="registerForm.get('password')"></app-password-error>

      <label class="input-label" for="passwordCheck">
        Passwort wiederholen{{
          fieldRequired(registerForm.get('passwordCheck')) ? '*' : ''
        }}
      </label>
      <div class="password-input-wrapper">
        <input
          [type]="showPasswordCheck ? 'text' : 'password'"
          class="form-control input-text"
          [class]="{
            'input-error':
              registerForm.get('passwordCheck').invalid &&
              registerForm.get('passwordCheck').touched,
            'input-success':
              registerForm.get('passwordCheck').valid &&
              registerForm.get('passwordCheck').touched,
          }"
          id="passwordCheck"
          formControlName="passwordCheck"
          placeholder="Passwort wiederholen"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-button"
          (click)="togglePasswordCheckVisibility()"
          [attr.aria-label]="
            showPasswordCheck ? 'Passwort verbergen' : 'Passwort anzeigen'
          ">
          <i
            [class]="
              showPasswordCheck
                ? 'fa-regular fa-eye-slash'
                : 'fa-regular fa-eye'
            "></i>
        </button>
      </div>
      <!-- Error Messages -->
      <app-password-error
        [control]="registerForm.get('passwordCheck')"></app-password-error>
      <div
        class="flex-r align-center gap-8 align-self-stretch"
        [class.invalid-checkbox]="
          registerForm.get('agbConfirmation').invalid &&
          registerForm.get('agbConfirmation').touched
        ">
        <div class="inwi-checkbox">
          <input
            id="agb"
            type="checkbox"
            name="agb"
            formControlName="agbConfirmation" />
        </div>
        <div class="flex-c align-start gap-4 flex-1-0-0">
          <label for="agb" class="font-regular-body-large">
            Hiermit bestätige ich meine Kenntnis von den
            <a class="font-color-black" href="/agb" target="_blank">AGB</a> und
            den
            <a class="font-color-black" href="/privacy-policy" target="_blank">
              Datenschutzinformationen </a
            >.
          </label>
        </div>
      </div>
      @if (
        registerForm.get('agbConfirmation').invalid &&
        registerForm.get('agbConfirmation').touched
      ) {
        <div class="inwi-error-container show-overflow">
          <div class="inwi-text-error font-regular-label-large">
            Sie müssen die AGB und Datenschutzinformationen akzeptieren.
          </div>
        </div>
      }
      <div class="flex-r align-center gap-8 align-self-stretch">
        <div class="inwi-checkbox">
          <input
            id="newsletterOptIn"
            type="checkbox"
            name="newsletterOptIn"
            formControlName="newsletterOptIn" />
        </div>
        <div class="flex-c align-start gap-4 flex-1-0-0">
          <label for="newsletterOptIn" class="font-regular-body-large">
            Für den Newsletter anmelden
          </label>
        </div>
      </div>
    </div>
    <div class="form-button flex-c">
      <button type="submit" class="inwi-text-button-large-primary">
        Registrieren
      </button>
      <button
        type="button"
        (click)="route('./login')"
        class="inwi-text-button-large">
        Login
      </button>
    </div>
  </form>
</div>
